import axios from 'axios';
import store from 'store';

const state = {
  customers: {},
  customer: {},
};

const mutations = {
  setCustomers: (st, payload) => {
    state.customers = payload;
  },
  setCustomer: (st, payload) => {
    st.customer = payload;
  },
};

const getters = {
  getCustomersFiltered: st => (page, q, sortBy, order) => {
    axios.get(`customers?page=${page}&q=${q}&sort=${sortBy}&order=${order}`).then(res => {
      st.customers = res.data;
    });
  },
};

const actions = {
  getCustomers: ({ commit }) => {
    commit('setCustomers', {});
    if (store.get('permissions').indexOf('companies.customers.index') >= 0) {
      axios.get(`customers`).then(res => {
        commit('setCustomers', res.data);
      });
    }
  },
  getCustomer: ({ commit }, customerId) => {
    axios.get(`customers/${customerId}`).then(res => {
      commit('setCustomer', res.data);
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/customers.js